import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { 
  SituRenderServiceWebApiClient,
  EnvironmentSettings,
  EnvironmentName,
  ReferenceKeyCuttoff,
  SaveEnvironmentsForBuilderRequest,
  GetProductionArtifactsRequest,
  ArtifactVersion,
  ProductName
} from 'siturenderservice-webapi-client';

@Component({
  selector: 'app-warp-environments',
  templateUrl: './warp-environments.component.html',
  styleUrls: ['./warp-environments.component.less']
})
export class WarpEnvironmentsComponent implements OnInit {
  productNameEnum = ProductName;
  @Input() allowEdit: boolean = false;
  @Input() environments: EnvironmentSettings[] = [];
  @Input() selectedCompany: string = '';
  @Input() selectedProduct: ProductName = ProductName.Panorama;
  @Output() reloadEnvironmentsEvent = new EventEmitter<string>();
  hasChanges: boolean = false;

  keyQueries: string[] = [
    'ifc',
    'software',
    'software\\bimviewer',
    'software\\pathtrace',
    'software\\ifc4tojson',
    'software\\situplanbundle',
    'software\\floorplantool', 
    'software\\vrbundlerunityproject', 
    'software\\lightmapandbundle',
    'software\\vanitygenerator',
    'vanityconfig',
  ];
  artifactsToRetain: ArtifactVersion[] | [];
  clearOverrides: boolean = false;

  constructor(
    private situRenderServiceClient: SituRenderServiceWebApiClient
  ) {
    this.artifactsToRetain = [];
  }

  ngOnInit(): void {

  }

  artifactsToRetainCount() {
    return this.artifactsToRetain.length;
  }

  onAddReferenceKeyCutoff(referenceKeyCuttoffs: ReferenceKeyCuttoff[]) {
    referenceKeyCuttoffs.push(
      new ReferenceKeyCuttoff(
        {
          query: '',
          cuttoffDate: undefined
        }));

    this.hasChanges = true;
  }

  onRemoveReferenceKeyCutoff(referenceKeyCuttoffs: ReferenceKeyCuttoff[], index: number) {
    referenceKeyCuttoffs.splice(index, 1);

    this.hasChanges = true;
  }

  clearCutoffDate(environment: EnvironmentSettings) {
    environment.defaultCuttoffDate = undefined;

    this.hasChanges = true;
  }

  saveWithConfirmation(confirmMsg: string) {
    if (!this.allowEdit) {
      return;
    }

    if (confirm(confirmMsg)) {
      this.save();
    }
  }

  save() {
    if (!this.allowEdit) {
      return;
    }

    var request = new SaveEnvironmentsForBuilderRequest();
    request.environments = this.environments;
    request.clearOverrides = this.clearOverrides;
    request.artifactsToRetain = this.artifactsToRetain;

    this.situRenderServiceClient.saveEnvironmentsForBuilder(request).then(response => {
      this.artifactsToRetain = [];
      this.clearOverrides = false;
      this.reloadEnvironmentsEvent.emit();
      this.hasChanges = false;
    }, error => {
    });
  }

  keepProductionArtifacts() {
    if (!this.allowEdit) {
      return;
    }

    var request = new GetProductionArtifactsRequest();
    request.builder = this.selectedCompany;
    request.product = this.selectedProduct;

    this.situRenderServiceClient.getProductionArtifacts(request).then(response => {
      this.artifactsToRetain = [...response.artifacts ?? []];
    }, error => {
    });

    this.hasChanges = true;
  }

  removeOverrides() {
    if (!this.allowEdit) {
      return;
    }

    this.clearOverrides = true;

    this.hasChanges = true;
  }

  getEnvironmentName(environmentName: EnvironmentName) {
    return EnvironmentName[environmentName];
  }

  deployStaging() {
    let staging = this.getEnvironment(EnvironmentName.Staging);
    let prod = this.getEnvironment(EnvironmentName.Production);
    let fallback = this.getEnvironment(EnvironmentName.Fallback);

    if (!staging) {
      throw new Error("Staging environment not found.");
    }

    let newProdDate = staging.defaultCuttoffDate;
    if (!newProdDate) {
      alert("Staging must have a Cut-off Date.");
      return;
    }

    if (confirm("Are you sure you want to send Staging to Production?")) {
      fallback.defaultCuttoffDate = prod.defaultCuttoffDate;
      prod.defaultCuttoffDate = newProdDate;

      fallback.referenceKeyCuttoffs = [...prod?.referenceKeyCuttoffs?.map(x => new ReferenceKeyCuttoff(x)) ?? []];
      prod.referenceKeyCuttoffs = [...staging?.referenceKeyCuttoffs?.map(x => new ReferenceKeyCuttoff(x)) ?? []];

      fallback.overrides = [...prod?.overrides ?? []];
      prod.overrides = [...staging?.overrides ?? []];
      this.hasChanges = true;
    }
  }

  deployFallback() {
    let prod = this.getEnvironment(EnvironmentName.Production);
    let fallback = this.getEnvironment(EnvironmentName.Fallback);

    let newProdDate = fallback.defaultCuttoffDate;
    if (!newProdDate) {
      alert("Fallback must have a Cut-off Date.");
      return;
    }

    if (confirm("Are you sure you want to rollback Production to FallBack?")) {
      prod.defaultCuttoffDate = newProdDate;
      prod.referenceKeyCuttoffs = [...fallback.referenceKeyCuttoffs?.map(x => new ReferenceKeyCuttoff(x)) ?? []];
      prod.overrides = fallback.overrides;
      this.hasChanges = true;
    }
  }

  getEnvironment(environmentName: EnvironmentName) {
    let environment = this.environments.find(x => x?.environment?.environment == environmentName);
    if (!environment) {
      throw new Error("Staging environment not found.");
    }
    return environment;
  }

  changeOccurred() {
    this.hasChanges = true;
  }
}
